<template>
    <div>
        <h1 class="title">Actualizar Contraseña</h1>

        <div class="column is-6-tablet">
            <form v-if="!passwordUpdated">
                <b-field>
                    <b-field label="Contraseña actual" expanded :type="passwordError ? 'is-danger' : ''" :message="passwordError ? 'Verifique los datos ingresados': ''">
                        <b-input v-model="currentPassword" type="password" password-reveal></b-input>
                    </b-field>
                </b-field>

                <b-field>
                    <b-field label="Nueva contraseña" expanded :type="passwordError ? 'is-danger' : ''" :message="passwordError ? 'Verifique los datos ingresados': 'La contraseña debe contener al menos 8 caracteres'">
                        <b-input v-model="newPassword" type="password" password-reveal></b-input>
                    </b-field>
                </b-field>

                <b-field>
                    <b-field>
                        <b-field label="Repetir nueva contraseña" :type="passwordError ? 'is-danger' : ''" :message="passwordError ? 'Verifique los datos ingresados': ''">
                            <b-input v-model="confirmation" type="password" password-reveal></b-input>
                        </b-field>
                    </b-field>
                </b-field>

                <b-button type="is-primary" @click="onSavePasswordSelected" :disabled="!canSave" :loading="isLoading">Guardar</b-button>
            </form>

            <div v-else>
                <h2 class="subtitle">La contraseña ha sido actualizada</h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'account-password',

        data() {
            return {
                passwordError: false,
                passwordUpdated: false,
                isLoading: false,
                currentPassword: '',
                newPassword: '',
                confirmation: ''
            }
        },

        computed: {
            customer() {
                return this.$store.state.customer.customer;
            },

            canSave() {
                return this.currentPassword.length > 0 && this.newPassword.length >= 8 && this.newPassword === this.confirmation;
            }
        },

        mounted() {
            this.passwordUpdated = false;
        },

        methods: {
            async onSavePasswordSelected() {
                this.passwordError = false;

                if(this.newPassword !== this.confirmation) {
                    this.passwordError = true;
                    return;
                }

                try {
                    this.isLoading = true;

                    let result = await this.$api.patch('/api/auth/password', {
                        current: this.currentPassword,
                        new: this.newPassword
                    });

                    this.passwordUpdated = true;
                }
                catch(err) {
                    this.passwordError = true;
                }
                finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>